var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"sicredi-cookies-root","data-dominioUUID":_vm.uuid,"data-enviroment":"PRD"}})
}
var staticRenderFns = []

export { render, staticRenderFns }